'use client'

import React from 'react'

import { Box } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'
import {
  cardSelectorDescriptionStyles,
  cardSelectorLabelStyles,
  cardSelectorStyles,
} from './Card.styles'

export type FlashCardProps = {
  colorScheme?: ColorScheme
  description?: string
  icon?: React.ReactNode
  isActive?: boolean
  label: string
  onClick?: () => void
}

export const FlashCard = ({
  colorScheme = 'dark',
  description,
  icon,
  isActive = false,
  label,
  onClick,
}: FlashCardProps) => (
  <Box
    aria-pressed={isActive}
    onClick={onClick}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        e.currentTarget.click()
      }
    }}
    role='button'
    tabIndex={0}
    {...cardSelectorStyles(isActive, colorScheme)}
  >
    {icon && (
      <Box flexShrink={0} height='32px' overflow='hidden' width='32px'>
        {icon}
      </Box>
    )}
    <Box as='p' {...cardSelectorLabelStyles(colorScheme)}>
      {label}
    </Box>
    {description && (
      <Box as='p' {...cardSelectorDescriptionStyles(colorScheme)}>
        {description}
      </Box>
    )}
  </Box>
)
